/**
 * Warstwa API: FAKTURY ITAM — wykrywanie duplikatu i odłożona ewidencja (polecenie właściciela 2026-10-02: „zadbaj o to, by sprawdzać,
 * czy faktura została już dodana”; po zapisie pytanie „Czy chcesz od razu ewidencjonować?”).
 *
 * Szkielet założony razem z modułem materiałów procedur (jeden właściciel index.js); trasy stawia backend faktur (ItamController):
 *  - `GET api/itam/invoices/duplikat?numer=&nip=&data=&brutto=&pomijajId=&czyProforma=` → `{ pewny: [...], podobne: [...] }`
 *    (każda pozycja: `{ id, numer, data, sprzedawca, brutto, czyProforma, dodal, dodanoAt, pozycji }`); `czyProforma` musi jechać
 *    z ekranu — proforma kontra faktura końcowa pod jednym numerem to „podobne”, nie „pewny”, tak samo jak przy zapisie;
 *  - `POST api/itam/invoices/{id}/ewidencja-odlozona` — „Nie teraz”: faktura oznaczona do ewidencji, powiadomienie imienne do autora.
 *
 * Kontrakt: `attach(api)` dostaje instancję axios z apiService.js i zwraca nazwane metody (nazwy unikalne — patrz attachApiModules).
 */
export function attach(api) {
    return {
        /**
         * Sprawdzenie, czy faktura o tym numerze (i NIP sprzedawcy) już jest w rejestrze.
         * @param {{ numer?: string, nip?: string, data?: string, brutto?: number|string, pomijajId?: string, czyProforma?: boolean }} params
         */
        duplikatFaktury: ({ numer, nip, data, brutto, pomijajId, czyProforma } = {}) =>
            api.get("/itam/invoices/duplikat", { params: { numer, nip, data, brutto, pomijajId, czyProforma: Boolean(czyProforma) } }),

        /** „Nie teraz” po zapisie faktury — odkłada ewidencję pozycji i wysyła przypomnienie autorowi. */
        ewidencjaOdlozonaFaktury: (id) => api.post(`/itam/invoices/${id}/ewidencja-odlozona`),
    };
}
